module.exports = __webpack_public_path__ + "img/tag.07f80887.svg";